
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38 38"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 299","cx":"18.999","cy":"18.999","r":"18.999","fill":"none"}}),_c('g',{attrs:{"data-name":"facebook"}},[_c('path',{attrs:{"data-name":"Path 74","d":"M23.261 17.747h-2.839v10.416h-4.311V17.747h-2.049v-3.66h2.049v-2.368a4.036 4.036 0 014.346-4.346l3.187.014v3.555h-2.312a.877.877 0 00-.914 1v2.154h3.219z","fill":"#fff"}})])])
          )
        }
      }
    